import React, { useState } from 'react';
import { COLORS, CYCLE_COLORS, ROUTINE_CYCLE, ROUTINE_DATA, getDayStyle } from '../utils/constants';

function fmtSecs(s) {
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
}

export default function DaySelector({ todayType, setTodayType, setTab, onGo, sessionSecs, ciclo, allowExpand }) {
  const [open, setOpen] = useState(false);
  const cycle = ciclo || ROUTINE_CYCLE;
  const style = getDayStyle(todayType);

  const handleClick = () => {
    if (allowExpand) {
      setOpen(!open);
    } else {
      if (setTab) setTab('gym');
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <div onClick={handleClick} style={{
        background: `linear-gradient(135deg, ${style.bg}, ${COLORS.card})`,
        border: `1px solid ${style.color}40`, borderRadius: 20, padding: "12px 18px", marginBottom: (open && allowExpand) ? 0 : 12,
        boxShadow: `0 8px 32px ${style.color}20`, cursor: "pointer",
        borderBottomLeftRadius: (open && allowExpand) ? 0 : 20, borderBottomRightRadius: (open && allowExpand) ? 0 : 20,
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <p style={{ color: COLORS.textMuted, fontSize: 11, letterSpacing: 2, textTransform: "uppercase", margin: "0 0 6px" }}>Sesión de hoy</p>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <h2 style={{ color: style.color, fontSize: 30, fontWeight: 900, margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{todayType}</h2>
              {onGo && todayType !== 'Descanso' && (
                <button
                  onClick={e => { e.stopPropagation(); setOpen(false); onGo(); }}
                  style={{
                    background: `linear-gradient(135deg, ${style.color}, ${style.color}cc)`,
                    border: 'none', borderRadius: 12, padding: '6px 16px',
                    color: '#fff', fontSize: 13, fontWeight: 900, cursor: 'pointer',
                    letterSpacing: 1, boxShadow: `0 4px 12px ${style.color}50`,
                  }}
                >GO</button>
              )}
              {sessionSecs !== null && sessionSecs !== undefined && (
                <span style={{
                  color: style.color, fontSize: 18, fontWeight: 900,
                  fontFamily: 'monospace', letterSpacing: 1,
                }}>{fmtSecs(sessionSecs)}</span>
              )}
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
            <div style={{ width: 52, height: 52, borderRadius: "50%", background: style.bg, border: `2px solid ${style.color}60`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, color: style.color }}>{style.icon}</div>
          </div>
        </div>
      </div>
      {open && allowExpand && (
        <div style={{ background: COLORS.card, border: `1px solid ${style.color}40`, borderTop: "none", borderRadius: "0 0 20px 20px", overflow: "hidden", marginBottom: 16 }}>
          {cycle.map(type => {
            const c = getDayStyle(type);
            const isActive = type === todayType;
            return (
              <div key={type} onClick={() => { setTodayType(type); setOpen(false); if (type !== "Descanso") setTab("gym"); }} style={{
                padding: "16px 24px", cursor: "pointer", display: "flex", alignItems: "center", gap: 14,
                background: isActive ? c.bg : "transparent",
                borderBottom: `1px solid ${COLORS.border}`,
              }}>
                <span style={{ fontSize: 22, color: c.color }}>{c.icon}</span>
                <span style={{ color: isActive ? c.color : COLORS.text, fontWeight: 700, fontSize: 17, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{type}</span>
                {isActive && <span style={{ marginLeft: "auto", color: c.color, fontSize: 11, fontWeight: 700 }}>✓ ACTIVO</span>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
